import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const correctUsername = "virtueistait@gmail.com";
    const correctPassword = "Birat@nagar@10";

    try {
      if (username === correctUsername && password === correctPassword) {
        onLogin("virtueistait@gmail.com");
        navigate("/inquiry");
      } else {
        setError("Invalid username or password");
      }
    } catch (err) {
      setError("An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-purple-100 to-pink-100 p-4">
      <div className="bg-white p-4 sm:p-6 rounded-xl shadow-2xl w-full max-w-md mx-auto mt-[10%]">
        <h2 className="text-xl sm:text-2xl font-bold mb-4 text-center text-gray-800 tracking-tight">Login</h2>
        {error && (
          <p className="text-red-500 text-sm mb-3 text-center bg-red-50 p-2 rounded-md">{error}</p>
        )}
        <div>
          <div className="mb-3 relative">
            <label className="block text-gray-700 text-sm font-semibold mb-2" htmlFor="username">
              Username
            </label>
            <div className="relative">
              <svg
                className="w-5 h-5 text-gray-500 absolute left-3 top-1/2 transform -translate-y-1/2"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
              </svg>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300"
                placeholder="Enter your email"
                disabled={loading}
              />
            </div>
          </div>
          <div className="mb-4 relative">
            <label className="block text-gray-700 text-sm font-semibold mb-2" htmlFor="password">
              Password
            </label>
            <div className="relative">
              <svg
                className="w-5 h-5 text-gray-500 absolute left-3 top-1/2 transform -translate-y-1/2"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.5 6c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5v2h-7V6z" />
              </svg>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300"
                placeholder="Enter your password"
                disabled={loading}
              />
            </div>
          </div>
          <button
            onClick={handleLogin}
            className={`w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white py-2 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg ${
              loading ? "opacity-50 cursor-not-allowed" : "hover:from-blue-600 hover:to-blue-700"
            }`}
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </div>
      </div>
      <p className="text-center text-gray-600 text-sm mt-4 font-medium">
        Virtueista IT Pvt. Ltd.
      </p>
    </div>
  );
};

export default Login;
